import _ from "lodash";

import {
  MENU_OPEN,
  MENU_CLOSE,
  SHOW_HEADER,
  HIDE_HEADER,
  SHOW_FOOTER,
  HIDE_FOOTER,
  SHOW_GLOBAL_TRACKER_MODAL,
  HIDE_MODALS,
  SHOW_ACTIVITIES_MODAL,
  SHOW_BASIC_MODAL,
  SHOW_GROWTH_MODAL,
  SHOW_DIET_DIAPER_MODAL,
  SHOW_MILESTONE_MODAL,
  SHOW_SLEEP_MODAL,
  SHOW_SAVE_ENTRY_MODAL,
  SHOW_UNSAVED_MODAL,
  SHOW_PREVIOUS_MODAL,
  SET_SELECTED_BABY,
  SET_GROWTH_TYPE,
  BABY_EDITOR_OPEN_MODAL,
  BABY_EDITOR_CLOSE_MODAL,
  BABY_CREATE_OPEN_MODAL,
  BABY_CREATE_CLOSE_MODAL,
  SHOW_LOGOUT_WARNING_MODAL,
  HIDE_LOGOUT_WARNING_MODAL
} from "../actions/ui";

import api from "../api";

const BABIES_LIST_SUCCESS = api.events.babiesList.actionSuccess;
const BASIC_RECORDS_LIST_SUCCESS = api.events.basicRecordsList.actionSuccess;
const GROWTH_RECORDS_LIST_SUCCESS = api.events.growthRecordsList.actionSuccess;
const DIET_DIAPER_RECORDS_LIST_SUCCESS =
  api.events.dietDiaperRecordsList.actionSuccess;
const MILESTONE_RECORDS_LIST_SUCCESS =
  api.events.milestoneRecordsList.actionSuccess;
const SLEEP_RECORDS_LIST_SUCCESS = api.events.sleepRecordsList.actionSuccess;

const modalState = {
  trackerModalShown: false,
  activitiesModalShown: false,
  basicModalShown: false,
  growthModalShown: false,
  dietDiaperModalShown: false,
  milestoneModalShown: false,
  sleepModalShown: false,
  saveEntryModalShown: false,
  unSavedModalShown: false,
  babyCreateModalShown: false,
  logoutWarningModalShown: false,
  currentModal: undefined
};

const defaultState = {
  menuShow: false,
  showHeader: true,
  showFooter: true,
  selectedBabyId: null,
  growthType: "weight",
  basicCallsMade: [],
  growthCallsMade: [],
  dietDiaperCallsMade: [],
  milestoneCallsMade: [],
  sleepCallsMade: [],
  editBabyId: null,
  ...modalState
};

export default function ui(state = defaultState, action) {
  switch (action.type) {
    case MENU_OPEN:
      return { ...state, menuShow: true };
    case MENU_CLOSE:
      return { ...state, menuShow: false };
    case SHOW_HEADER:
      return { ...state, showHeader: true };
    case HIDE_HEADER:
      return { ...state, showHeader: false };
    case SHOW_FOOTER:
      return { ...state, showFooter: true };
    case HIDE_FOOTER:
      return { ...state, showFooter: false };
    case SHOW_GLOBAL_TRACKER_MODAL:
      return {
        ...state,
        ...modalState,
        trackerModalShown: true,
        currentModal: "trackerModal"
      };
    case HIDE_MODALS:
      return { ...state, ...modalState };
    case SHOW_ACTIVITIES_MODAL:
      return {
        ...state,
        ...modalState,
        activitiesModalShown: true,
        previousModal: state.currentModal,
        currentModal: "activitiesModal"
      };
    case SHOW_BASIC_MODAL:
      return {
        ...state,
        ...modalState,
        basicModalShown: true,
        previousModal: state.currentModal,
        currentModal: "basicModal"
      };
    case SHOW_DIET_DIAPER_MODAL:
      return {
        ...state,
        ...modalState,
        dietDiaperModalShown: true,
        previousModal: state.currentModal,
        currentModal: "dietDiaperModal"
      };
    case SHOW_GROWTH_MODAL:
      return {
        ...state,
        ...modalState,
        growthModalShown: true,
        previousModal: state.currentModal,
        currentModal: "growthModal"
      };
    case SHOW_MILESTONE_MODAL:
      return {
        ...state,
        ...modalState,
        milestoneModalShown: true,
        previousModal: state.currentModal,
        currentModal: "milestoneModal"
      };
    case SHOW_SLEEP_MODAL:
      return {
        ...state,
        ...modalState,
        sleepModalShown: true,
        previousModal: state.currentModal,
        currentModal: "sleepModal"
      };
      case SHOW_SAVE_ENTRY_MODAL:
        return {
          ...state,
          ...modalState,
          previousModal: state.currentModal,
          saveEntryModalShown: true
        };
    case SHOW_UNSAVED_MODAL:
      return {
        ...state,
        ...modalState,
        previousModal: state.currentModal,
        unSavedModalShown: true
      };
    case SHOW_LOGOUT_WARNING_MODAL:
      return {
        ...state,
        logoutWarningModalShown: true
      };
    case HIDE_LOGOUT_WARNING_MODAL:
      return {
        ...state,
        logoutWarningModalShown: false
      };
    case SHOW_PREVIOUS_MODAL:
      return {
        ...state,
        ...modalState,
        currentModal: state.previousModal,
        [`${state.previousModal}Shown`]: true
      };
    case SET_SELECTED_BABY:
      return {
        ...state,
        selectedBabyId: action.payload
      };
    case SET_GROWTH_TYPE:
      return {
        ...state,
        growthType: action.payload
      };
    case BABIES_LIST_SUCCESS: {
      const selectedBabyId =
        state.selectedBabyId ||
        _.chain(action.data)
          .sortBy("name")
          .map(o => o.id)
          .head()
          .value();

      return {
        ...state,
        selectedBabyId
      };
    }
    case BASIC_RECORDS_LIST_SUCCESS: {
      return {
        ...state,
        basicCallsMade: _.uniq(
          state.basicCallsMade.concat(action.request.pathvars.babyId)
        )
      };
    }
    case GROWTH_RECORDS_LIST_SUCCESS: {
      return {
        ...state,
        growthCallsMade: _.uniq(
          state.growthCallsMade.concat(action.request.pathvars.babyId)
        )
      };
    }
    case DIET_DIAPER_RECORDS_LIST_SUCCESS: {
      return {
        ...state,
        dietDiaperCallsMade: _.uniq(
          state.dietDiaperCallsMade.concat(action.request.pathvars.babyId)
        )
      };
    }
    case MILESTONE_RECORDS_LIST_SUCCESS: {
      return {
        ...state,
        milestoneCallsMade: _.uniq(
          state.milestoneCallsMade.concat(action.request.pathvars.babyId)
        )
      };
    }
    case SLEEP_RECORDS_LIST_SUCCESS: {
      return {
        ...state,
        sleepCallsMade: _.uniq(
          state.sleepCallsMade.concat(action.request.pathvars.babyId)
        )
      };
    }
    case BABY_EDITOR_OPEN_MODAL:
      return {
        ...state,
        editBabyId: action.babyId
      };
    case BABY_EDITOR_CLOSE_MODAL:
      return {
        ...state,
        editBabyId: null
      };
    case BABY_CREATE_OPEN_MODAL:
      return {
        ...state,
        babyCreateModalShown: true
      };
    case BABY_CREATE_CLOSE_MODAL:
      return {
        ...state,
        babyCreateModalShown: false
      };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/ui.js